export default {
	title: "Themes",
	darkMode: "Dark Mode",
	orixas: {
		ori: "ORI",
		exu: "Exú",
		ogum: "Ogum",
		oxossi: "Oxóssi",
		xango: "Xangô",
		oxum: "Oxum",
		iemanja: "Iemanjá",
		oxala: "Oxalá",
		nana: "Nanã",
		iansa: "Iansã",
		ibeji: "Ibeji",
	},
	descriptions: {
		ori: "Default ORI system theme",
		exu: "Guardian of the paths - Black with Red",
		ogum: "Orixá of paths and war - Red",
		oxossi: "Orixá of hunting and abundance - Green and Blue",
		xango: "Orixá of justice and lightning - Brown and White",
		oxum: "Orixá of rivers and love - Dark Blue",
		iemanja: "Queen of the sea - Blue and White",
		oxala: "Father of all orixás - Pure White",
		nana: "Ancestral orixá - Purple and Lilac",
		iansa: "Lady of winds and storms - Yellow and Coral",
		ibeji: "Twin orixás of joy - Light Blue and Pink",
	},
};
